import { UpdateAccountCustomHead } from '@components/common/customHead';
import UpdateAccount from '@components/updateAccount';

const UpdateAccountPage = () => {
  return (
    <>
      <UpdateAccountCustomHead />
      <UpdateAccount />
    </>
  );
};

export default UpdateAccountPage;
